'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import unescapedText from 'I18n/utils/unescapedText';
import LanguageSelect from 'ui-addon-i18n/components/LanguageSelect';
import validLanguages from 'ecosystem-marketplace-core/constants/groupTags/SupportedLanguages';

const AppLanguagesSelect = ({
  onChange,
  value
}) => {
  const handleChange = useCallback(({
    target: {
      value: selectValue
    }
  }) => {
    onChange(Immutable.Set(selectValue));
  }, [onChange]);
  return /*#__PURE__*/_jsx(LanguageSelect, {
    clearable: true,
    multi: true,
    onChange: handleChange,
    placeholder: unescapedText('appMarketplace.storefront.filters.appLanguages.selectPlaceholder'),
    validLanguages: validLanguages,
    value: value.toArray()
  });
};

AppLanguagesSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: ImmutablePropTypes.iterableOf(PropTypes.oneOf(validLanguages)).isRequired
};
export default AppLanguagesSelect;